import { BlocksValue } from "../../../contexts/blocks";
import { StylesValue } from "../../../contexts/styles";
import PropInput from "./propinput";
import { useState, useContext, useEffect } from "react";
import useParentSources from "../../../utils/useparentsources.js";
import styles from "./styles.module.css";
export default function Props({ block, path, onChange }) {
  const blocks = useContext(BlocksValue);
  const stylesValue = useContext(StylesValue);
  const [schema, setSchema] = useState(null);
  const sources = useParentSources(path);

  useEffect(() => {
    const _schema = blocks.find((x) => x.name === block.component);
    setSchema(_schema);
  }, [block.component]);

  const onSelectStyle = (styleId) => {
    const newProps = { ...block.props };
    if (styleId !== "") {
      const _style = stylesValue.find((x) => x.id === styleId);
      if (_style) {
        schema.props
          .filter((p) => p.editorParams.styleName)
          .forEach((p) => {
            if (_style.props[p.name]) {
              newProps[p.name] = _style.props[p.name];
            } else if (p.editorParams.default) {
              newProps[p.name] = p.editorParams.default;
            }
          });
      }
    }
    const newBlock = { ...block, props: newProps, style: styleId };
    onChange(newBlock);
  };
  if (!schema) {
    return null;
  }
  return (
    <div>
      {schema.props
        .filter((x) => !x.editorParams.styleName)
        .map((prop, index) => {
          return (
            <PropInput
              onChange={onChange}
              sources={sources}
              index={index}
              key={prop.name}
              block={block}
              prop={prop}
            />
          );
        })}
      <div className={styles.propInput}>
        <div className={styles.propTitle}>Select Style</div>
        <select
          className={styles.select}
          onChange={(e) => onSelectStyle(e.target.value)}
          value={block.style ? block.style : ""}
        >
          <option value=""></option>
          {stylesValue
            .filter((s) => s.component === block.component)
            .map((s) => {
              return (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              );
            })}
        </select>
      </div>

      {!block.style &&
        schema.props
          .filter((x) => x.editorParams.styleName)
          .map((prop, index) => {
            return (
              <PropInput
                onChange={onChange}
                sources={sources}
                index={index}
                key={prop.name}
                block={block}
                prop={prop}
              />
            );
          })}
    </div>
  );
}
